import React from 'react';
import { Row, Col, Image } from 'react-bootstrap';
import { injectIntl } from 'react-intl';

const ImageItem = ({ image, author, title, description }) => (
  <Row>
    <Col md={12} xs={12} style={{ textAlign: 'center' }}>
      <div className="image-container">
        <Image style={{ height: 400 }} src={image} />
      </div>
      <h1 style={{ fontSize: 50 }}>
        {' '}
        <span style={{ fontWeight: 'bold' }}>{title}</span>
        {description}
      </h1>
      <a
        style={{ fontSize: 10 }}
        href="http://www.freepik.com"
      >{`Designed by ${author} / Freepik`}</a>
    </Col>
  </Row>
);

export default injectIntl(ImageItem);
